import { render, staticRenderFns } from "./Accruals.vue?vue&type=template&id=44197270&"
import script from "./Accruals.vue?vue&type=script&lang=js&"
export * from "./Accruals.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports